export const TABS = [
    {
        title: 'Рейтинг',
        theme: 'light',
        value: 'rating',
    },
    {
        title: 'О рейтинге',
        theme: 'light',
        value: 'about',
    },
];
export const RATINGS_START_YEAR = 2005;
export const RATINGS_DEFAULT_YEAR = new Date().getFullYear();
export const RATINGS_DROPDOWN_YEARS = createDropdownYear();
function createDropdownYear() {
    const years = [];
    for (let year = RATINGS_START_YEAR; year <= RATINGS_DEFAULT_YEAR; year++) {
        years.unshift({
            title: String(year),
            value: String(year),
        });
    }
    return years;
}
